export const CACHE_TIME_1_DAY = 1000 * 60 * 60 * 24;
export const CACHE_TIME_5_MINUTES = 1000 * 60 * 5;
export const CACHE_TIME_10_MINUTES = 1000 * 60 * 10;
export const CACHE_TIME_1_WEEK = 1000 * 60 * 60 * 24 * 7;
export const CACHE_TIME_1_MINUTE = 1000 * 60;
export const CACHE_TIME_30_SECONDS = 1000 * 30;
